<div class="summary-header-container">
  <div class="case-playback-wrapper">
    <div class="case-playback">

      <div class="left-side">
        <span class="wrap-around">

          <span class="case-id">
            <span class="bo-grey-text">{{referenceDataLabels.VirtualOfficeColCaseID | localizeLabel}} </span>
            <a class="link" [ngClass]="{'red-flag': model?.WasMaterialChangeApplied}"
              [routerLink]="['/caseOverview', model?.CaseNumberAsHash, 'caseSummary']">{{model?.CaseNumber}}</a>
          </span>

          <span class="applicants"></span>
          <span class="bo-grey-text"> {{referenceDataLabels.BackOfficeResultsApplicants|localizeLabel}} </span>
          <span>{{model?.AllApplicantsFullNameCache}}</span>
          <span *ngIf="displayAddApplicantLink" class="link" (click)="addApplicant()">+
            {{referenceDataLabels.Add|localizeLabel}} </span>

        </span>
      </div>

      <div class="right-side">
        <div class="advice-notes-container">
          <ng-container *ngIf="logoPath">
            <img class="header-small-logo" [src]="logoPath" alt="logo">
          </ng-container>
          <ng-container *ngIf="isCallInProgress && !isProductPicker">
            <div class="association associated bo-label-text" *ngIf="isCallAssociated"
              [boiPermissionChecker]="[userPermissions.CallLogging]" (click)="setAssociatedCaseToCall.emit(undefined)"
              [innerHtml]="referenceDataLabels.CallCaseAssociatedToCall | localizeLabel"></div>

            <div class="association not-associated bo-label-text" *ngIf="!isCallAssociated"
              [boiPermissionChecker]="[userPermissions.CallLogging]"
              (click)="setAssociatedCaseToCall.emit(model.CaseNumber)"
              [innerHtml]="referenceDataLabels.CallCaseNotAssociatedToCall | localizeLabel"></div>
          </ng-container>

          <ng-container *ngIf="model?.IsAdvisedCase">
            <div class="link" (click)="adviceNotesDialogOpened=true"
              [innerHtml]="referenceDataLabels.ViewAdviceNotes|localizeLabel"></div>

            <ng-container *ngIf="adviceNotesDialogOpened">
              <boi-advice-notes-dialog [(opened)]="adviceNotesDialogOpened" [caseId]="model.CaseNumberAsHash">
              </boi-advice-notes-dialog>
            </ng-container>
          </ng-container>

          <div class="save-and-close" (click)="goToCaseHub()"></div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isProductPicker" class="application-playback pt-14">
    <div class="left-side">
      <span class="bo-title-text mr-24 no-wrap">{{headerTextName | localizeLabel}}</span>

      <div *ngIf="model" class="bo-label-text pt-14 mr-24 no-wrap">
        <span *ngIf="isGreenBulletDisplayRequired(model.CaseStatusCode)" class="decision-action__accepted">
        </span>
        <span boiCategorizeCaseStatus [(caseStatus)]="model.CaseStatusCode">
          {{model.CaseStatusCode|localizeOption:(model.CaseType === referenceDataOptionLists.CaseTypeSwitchOption ? referenceDataOptionLists.SwitchCaseStatus : referenceDataOptionLists.CaseStatus)}}
        </span>
      </div>

      <span class="bo-grey-text pt-14 mr-4 mb-14">
        {{referenceDataLabels.CaseSummaryHeaderProduct | localizeLabel}}</span>
      <div class="bo-info-text product-details pt-14 mb-14">
        <span *ngIf="model?.ProductNameCache">{{model.ProductNameCache}} |&nbsp;</span>

        <span *ngIf="model?.LoanAmountCache > 0">
          {{model.LoanAmountCache|currency:(referenceDataLabels.Currency|localizeLabel)}}
          {{referenceDataLabels.Loan|localizeLabel}} |&nbsp; </span>

        <span *ngIf="model?.LtvCache > 0"> {{referenceDataLabels.LTV|localizeLabel}}
          {{model.LtvCache | ceil}} % |&nbsp;</span>

        <span *ngIf="model?.LoanTermYearsCache > 0">{{model.LoanTermYearsCache}}
          {{referenceDataLabels.YrTerm|localizeLabel}}</span>
      </div>
    </div>


    <ng-container *ngIf="displayAdviceTabLink">
      <a class="link no-wrap pt-14"
        [routerLink]="['/caseOverview', model?.CaseNumberAsHash, 'caseAdvice']">{{referenceDataLabels.GoBackToAdviceTab | localizeLabel}}</a>
    </ng-container>
  </div>
</div>